import './styles.css';
import Layout from 'components/seller/Layout';
import Cards from 'components/seller/dashboard/Cards';
import EarningChart from 'components/seller/dashboard/EarningChart';
import CancelBookings from 'components/seller/dashboard/CancelBookings';
import BookingDetails from 'components/seller/dashboard/BookingDetails';



const SellerDashboard = () => {
    return (
        <Layout>
            <Cards />
            <div className='mt-6 flex justify-between gap-6 lg:flex-row flex-col'>
                <div className='flex-[0.7]'>
                    <EarningChart />
                </div>
                <div className='flex-[0.3]'>
                    <CancelBookings />
                </div>
            </div>
            <div className='mt-6'>
                <BookingDetails />
            </div>
        </Layout>
    )
}

export default SellerDashboard